import { Context } from "@nuxt/types/app";
import { isFinite } from "lodash-es";

interface KbFromMbPlugin {
  getKBFromMB(number: number): number;
}

export default function (context: Context): KbFromMbPlugin {
  function getKBFromMB(number: number): number {
    if (!isFinite(number)) {
      return 0;
    }

    return number * 1024;
  }

  return { getKBFromMB };
}
